module.exports = __webpack_public_path__ + "img/erp-logos_0028_myob.ff9bbd2b.jpg";